import React from 'react'

const InternetMainContent = () => {
    return (
        <>
            <section className="services-details-area ptb-80 pb-2">
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-6 services-details">
                            <div className="ml-about-content">
                                {/* <h2>IoT App Development Company</h2> */}
                                <h1> IoT App Development Company : Where Vision Meets Technology</h1>
                                <div className="bar" />
                                {/* <p>As of now, it appears that IoT company is here to stay.</p> */}
                                <p>As of now, it appears that <b>IoT App Development company</b> is here to stay.</p>
                                <p>
                                    Even though IoT has been the underlying technology in the research
                                    and defense field for many years now, it has gained pace in recent
                                    years by stealthily creeping up the consumer industry and
                                    transfiguring the conventional working of machines by instituting
                                    automated Machine 2 Machine communications.
                                </p>
                                <p>
                                    Pledging to make our world infinitely easier, ‘Internet of Things’
                                    is deftly eliminating the need for human involvement and netting in
                                    the conceptualization of automation into our everyday life.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details-image">
                            <img
                                src="assets/img/service-detail-image/5.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="row  mt-2">
                        <div className="services-details-desc" style={{ padding: 11 }}>
                            {/* <p>
                                Alobha Technologies, IOT Company in India, offers a broad set of
                                services in Internet of Things software development to meet all your
                                business needs. Our team of experienced professionals is capable of
                                delivering end-to-end Internet of Things App Development services at
                                affordable prices.
                            </p> */}
                            <p>Alobha Technologies, <b>Best IoT App Development Company</b> in India, offers a broad set of services in Internet of Things software development to meet all your business needs. Our team of experienced professionals is capable of delivering end-to-end IoT App Development services at affordable prices.</p>
                            <p>
                                IoT app used to monitor and control the devices, activities from
                                anywhere and anytime. The mobile app will help the administrator to
                                send commands to the smart devices in order to make them to perform
                                the required action. Identifying the devices, the cloud will send the
                                related request to the appropriate sensor network using gateways.
                            </p>
                            <p>
                                The sensor network will process the required request and will send the
                                reply back to the cloud. The cloud will find the user who had
                                requested the data and push the required data to app.
                            </p>
                            {/* <p>
                                <strong>IoT Apps Development offers:</strong>
                            </p> */}
                            <h3 style={{ fontSize: "1rem", textAlign: "justify", color: "#45494d", lineHeight: "1.45" }}>
                                <strong>IoT Apps Development offers:</strong>
                            </h3>
                            <p>
                                IP Addresses: Ip addresses play a vital role in IoT system the latest
                                version of the internet protocol, IPv5 make IoT smarter than ever.
                            </p>
                            {/* <p>
                                <strong>IoT gateways</strong>
                            </p> */}
                            <h3 style={{ fontSize: "1rem", textAlign: "justify", color: "#45494d", lineHeight: "1.45" }}>
                                <strong>IoT gateways</strong>
                            </h3>
                            <p>
                                IoT gateways is a form of solution that connects the devices to the
                                internet through communication modes like wifi, bluetooth smart, Wi-Fi
                                and wireless etc. This setup also enables the devices to communicate
                                with each other.
                            </p>
                            {/* <p>
                                <strong>
                                    As IoT Company in India, Our IoT services are as follows:
                                </strong>
                            </p> */}
                            <h2 style={{ fontSize: "1rem", textAlign: "justify", color: "#45494d", lineHeight: "1.45" }}>
                                <strong>Our IoT App Development services:</strong>
                            </h2>
                            <ul className="text_color">
                                <li>IoT hardware development</li>
                                <li>Embedded hardware prototyping</li>
                                <li>IoT gateway development</li>
                                <li>IoT node development</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 services-details-image">
                            <img
                                src="assets/img/service-detail-image/6.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                            <div className="services-details-desc">
                                <p>
                                    Our Approach as simple and powerful as IOT’s concept of-Enabling
                                    devices to communicate intelligently through the internet.
                                </p>
                                <p>
                                    <strong>Think:</strong>
                                </p>
                                <p>
                                    Work with the client in the IOT strategy and thinking through the
                                    entire process determining how to creating and modifying existing
                                    products and services will changes the user of customer experience.
                                    Choose the right hardware and cloud infrastructure.
                                </p>
                                <p></p>
                                <p>
                                    <strong>Create:</strong>
                                </p>
                                <p>
                                    Design and develop the IOT application focusing on delivering
                                    impeccable customer experiences, as well as gaining insights into
                                    customers and recurring revenue opportunities.
                                </p>
                                <p>
                                    <strong>Think:</strong>
                                </p>
                                <p>
                                    Build analytics capability for business intelligence &amp; ability
                                    to extending the infrastructure to other business processes.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                <p>
                                    <strong>
                                        Our IoT Company Solutions add values to your business by adding
                                        the benefits like:
                                    </strong>
                                </p>
                                <div className="services-details-accordion">
                                    <ul className="accordion">
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */}Real-time effective
                                                decision making
                                            </a>
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */}Automated and optimized
                                                processes
                                            </a>
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */}Enhanced processes in
                                                complex scenarios
                                            </a>
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */}Optimized use of
                                                resources
                                            </a>
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */}Improved marketing
                                                automation
                                            </a>
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */}Smart and enhanced supply
                                                chain
                                            </a>
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */}Better revenue generation
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <br />
                    <br /> */}
                </div>
            </section>

        </>
    )
}

export default InternetMainContent